import {
  ORIGIN,
  DESTINATION,
} from 'components/modules/pricing/lane-rates-v2/lane-rates-v2-constants';

export const createErrorMessage = (error) => {
  const SPACER = ' - ';
  const row = error.row || '';
  const message = error.message ? SPACER.concat(error.message) : '';
  const cause = error.cause ? SPACER.concat(error.cause) : '';
  return 'Lane Rate '.concat(row).concat(cause).concat(message);
  // Lane Rate 1 - XX - invalid state
  // Lane Rate 3 - customerId - customerId is required
};

export const getLocationFields = (type) => {
  if (type === DESTINATION) {
    return {
      customZoneField: 'destinationZone',
      customZoneNameField: 'destinationZoneName',
      stateField: 'destinationState',
      cityField: 'destinationCity',
      zipField: 'destinationZip',
    };
  }
  return {
    customZoneField: 'originZone',
    customZoneNameField: 'originZoneName',
    stateField: 'originState',
    cityField: 'originCity',
    zipField: 'originZip',
  };
};

export const getDefaultLocationFields = (type) => {
  if (!type) {
    return null;
  }
  if (type === DESTINATION) {
    return {
      destinationZone: null,
      destinationZoneName: null,
      destinationCity: null,
      destinationZip: null,
    };
  }
  if (type === ORIGIN)
    return {
      originZone: null,
      originZoneName: null,
      originCity: null,
      originZip: null,
    };
};

export const isZipCode = (location) => {
  const US_ZIP_REGEX = /^\d+$/;
  return US_ZIP_REGEX.test(location);
};

export const laneRatesMapper = async (laneRates) => {
  if (!laneRates || !Array.isArray(laneRates)) {
    return [{}];
  }

  const mappedLaneRates = await Promise.all(
    laneRates.map(async (laneRate) => {
      const entries = Object.entries(laneRate);
      entries.forEach(([key, laneRateValue]) => {
        if (laneRateValue === 'NULL') {
          delete laneRate[key];
        }
      });

      if (!Array.isArray(laneRate?.rateConditions)) {
        const keys = Object.keys(laneRate?.rateConditions) || [];
        laneRate.rateConditions = keys.map((key) => {
          const rateCondition = { ...laneRate?.rateConditions[key], type: key };

          if (rateCondition.type === 'equipmentSize') {
            rateCondition.criteria = parseInt(rateCondition.criteria, 10);
          }

          if (rateCondition.type === 'hazardous') {
            rateCondition.criteria = rateCondition.criteria === 'Yes';
          }

          return rateCondition;
        });
      }

      if (laneRate?.commitment && laneRate?.commitmentType === 'weekly') {
        laneRate.weeklyCommitment = laneRate.commitment;
      }

      return {
        ...laneRate,
        customerName: laneRate.name,
        customerId: laneRate.customer,
      };
    }),
  );

  return mappedLaneRates;
};

export const mapLaneRatesPayload = (laneRates, action) => {
  return laneRates.map((laneRate) => {
    if (laneRate?.rateConditions && laneRate?.rateConditions.length) {
      laneRate.rateConditions = laneRate.rateConditions.map((rc) => {
        if (action === 'update') {
          rc.lanerateId = laneRate.id;
        }

        if (rc.type === 'hazardous') {
          rc.criteria = rc.criteria === true ? 'Yes' : 'No';
        }
        return rc;
      });
    }
    return laneRate;
  });
};

const formatFilterObject = (filters = {}) =>
  Object.entries(filters).reduce((filterArray, [key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((subValue) => filterArray.push([key, subValue]));
    } else {
      filterArray.push([key, value]);
    }
    return filterArray;
  }, []);

const formatSortingArray = (sorting = []) =>
  sorting.reduce((sortingArray, { id: sortColumn, desc }) => {
    sortingArray.push(
      ...Object.entries({ sortColumn, sortDirection: desc ? 'DESC' : 'ASC' }),
    );
    return sortingArray;
  }, []);

export const getParamString = ({ filters, sorting, pagination }) => {
  let params = [
    ...formatFilterObject(filters),
    ...formatSortingArray(sorting),
    ...Object.entries(pagination || {}),
  ];
  return new URLSearchParams(params).toString();
};
